<template>
	<div class="page">
		<component :is="componentName"></component>
	</div>
</template>

<style scoped="scoped">

</style>

<script>
	import Download from '@/components/service/Download.vue'
	import Gongzi from '@/components/service/Gongzi.vue'
	import HeTong from '@/components/service/HeTong.vue'

	export default {
		name: 'Service',
		components: {
			Gongzi,
			Download,
			HeTong
		},
		data() {
			return {
				componentName: null,
			}
		},
		created() {
			const id = this.$route.query.id
			if (id === '10') {
				this.componentName = 'Download';
			} else if (id === '20') {
				this.componentName = 'Gongzi';
			} else if (id === '30') {
				this.componentName = 'HeTong';
			}
		}
	}
</script>
